import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import api from '../utils/api'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [ndaAccepted, setNdaAccepted] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await api.get('/auth/me')
        setUser(res.data)
        setIsAuthenticated(true)
        setNdaAccepted(!!res.data.nda_accepted_at)
      } catch {
        setUser(null)
        setIsAuthenticated(false)
        setNdaAccepted(false)
      } finally {
        setLoading(false)
      }
    }
    checkAuth()
  }, [])

  const login = useCallback(async (email) => {
    const res = await api.post('/auth/login', { email })
    return res.data
  }, [])

  const logout = useCallback(async () => {
    try {
      await api.post('/auth/logout')
    } catch {}
    setUser(null)
    setIsAuthenticated(false)
    setNdaAccepted(false)
  }, [])

  const acceptNDA = useCallback(async (fullName, email, phone) => {
    const res = await api.post('/auth/nda', { full_name: fullName, email, phone })
    setNdaAccepted(true)
    if (res.data.user) setUser(res.data.user)
    return res.data
  }, [])

  const register = useCallback(async (token, email, fullName) => {
    const res = await api.post('/auth/register', { token, email, full_name: fullName })
    return res.data
  }, [])

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, ndaAccepted, loading, login, logout, acceptNDA, register }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
